import { render } from "./NewProject.vue?vue&type=template&id=e1d30d56&scoped=true&ts=true"
import script from "./NewProject.vue?vue&type=script&lang=ts"
export * from "./NewProject.vue?vue&type=script&lang=ts"

import "./NewProject.vue?vue&type=style&index=0&id=e1d30d56&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d30d56"]])

export default __exports__